export const womenLeadersCoverStoriesConstants = {
  GET_WOMEN_LEADERS_DATA_FAILURE: "GET_WOMEN_LEADERS_DATA_FAILURE",
  GET_WOMEN_LEADERS_DATA_SUCCESS: "GET_WOMEN_LEADERS_DATA_SUCCESS",

  GET_COVER_STORIES_DATA_FAILURE: "GET_COVER_STORIES_DATA_FAILURE",
  GET_COVER_STORIES_DATA_SUCCESS: "GET_COVER_STORIES_DATA_SUCCESS",
};
